/**
 * Picks the banner language: the page's lang attribute, then the browser languages,
 * then the banner default. "pt-BR" matches "pt-BR" first and "pt" second.
 */
export function pickLanguage(
  available: string[],
  preferred: readonly string[],
  fallback: string,
): string {
  const lower = available.map((code) => code.toLowerCase());
  for (const wanted of preferred) {
    if (!wanted) {
      continue;
    }
    const code = wanted.toLowerCase();
    const exact = lower.indexOf(code);
    if (exact >= 0) {
      return available[exact];
    }
    const base = lower.indexOf(code.split("-")[0]);
    if (base >= 0) {
      return available[base];
    }
  }
  return fallback;
}
